(function () {
  'use strict';

  var STORAGE_KEY = 'wl_tryon_selection_v1';
  var BOOKING_KEY = 'wl_tryon_booking_v1';

  /* ≤30 km of Cheltenham VIC 3192 — fallback when API not set */
  var TRYON_POSTCODE_RANGES = [[3000,3006],[3008,3008],[3010,3013],[3015,3016],[3018,3020],[3025,3028],[3031,3032],[3034,3034],[3039,3042],[3044,3044],[3050,3058],[3060,3060],[3065,3068],[3070,3073],[3078,3079],[3081,3081],[3083,3088],[3093,3095],[3101,3109],[3111,3111],[3113,3115],[3121,3138],[3141,3156],[3158,3202],[3204,3207],[3765,3765],[3767,3767],[3785,3789],[3791,3791],[3800,3800],[3802,3807],[3910,3911],[3930,3930],[3975,3977]];

  /* Greater Melbourne — interest form when outside Try-On zone */
  var MELBOURNE_METRO_RANGES = [
    [3000, 3211],
    [3335, 3341],
    [3427, 3444],
    [3750, 3811],
    [3910, 3920],
    [3926, 3944],
    [3975, 3978],
    [3980, 3984]
  ];

  var MSG_POSTCODE_OK = 'Great news! Home Try-On is available at this postcode.';
  var MSG_POSTCODE_OUT =
    'Sorry — Home Try-On isn’t available for this postcode. We currently offer the service within 30 km of Cheltenham, Melbourne. You can still shop online with standard delivery.';
  var MSG_POSTCODE_MEL_INTEREST =
    'Home Try-On isn’t available at this Melbourne postcode yet (we cover within 30 km of Cheltenham).';
  var MSG_INTEREST_OK = 'Thanks — we’ll be in touch within 24 hours.';
  var MSG_ZONE_NOTE = '*Home Try-On is available within 30 km of Cheltenham, Melbourne.';

  var TITLES = {
    1: 'Your Try-On Selection',
    2: 'Where should we deliver?',
    3: 'Choose your appointment',
    4: 'Review & pay',
    5: 'Booking confirmed!'
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function isoDate(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function loadSelection() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveSelection(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isTryOnCartNote(note) {
    var n = String(note || '');
    return /HOME TRY-ON BOOKING/i.test(n) || /Booking type:\s*Home Try-On/i.test(n);
  }

  function cartHasTryOnFee(cart) {
    return (cart && cart.items ? cart.items : []).some(function (line) {
      if (!line) return false;
      if (line.handle === 'home-try-on-service-fee') return true;
      var props = line.properties || {};
      if (props._wl_tryon === '1' || props['_wl_tryon'] === '1') return true;
      if (props['Booking type'] === 'Home Try-On') return true;
      return false;
    });
  }

  function clearTryOnNoteFields() {
    qsa(
      'textarea[name="note"], textarea#CartSpecialInstructions, textarea[name="attributes[note]"], [data-cart-note] textarea, .t4s-mini_cart textarea[name="note"]'
    ).forEach(function (el) {
      if (el && isTryOnCartNote(el.value)) el.value = '';
    });
  }

  var clearingTryOnNote = false;

  /** Clear Shopify cart note + booking session when Try-On fee is no longer in cart. */
  function clearStaleTryOnNote() {
    if (clearingTryOnNote) return Promise.resolve();
    clearingTryOnNote = true;
    try {
      sessionStorage.removeItem(BOOKING_KEY);
    } catch (e) {}
    clearTryOnNoteFields();
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: '' })
    })
      .catch(function () {})
      .finally(function () {
        clearingTryOnNote = false;
        clearTryOnNoteFields();
      });
  }

  function syncTryOnCartNote(cart) {
    if (!cart) return Promise.resolve();
    if (!isTryOnCartNote(cart.note)) return Promise.resolve();
    if (cartHasTryOnFee(cart)) return Promise.resolve();
    return clearStaleTryOnNote();
  }

  function refreshAndSyncTryOnNote() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(syncTryOnCartNote)
      .catch(function () {});
  }

  function installCartNoteGuard() {
    if (window.__wlTryOnCartNoteGuard) return;
    window.__wlTryOnCartNoteGuard = true;
    var origFetch = window.fetch;
    if (typeof origFetch !== 'function') return;
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) {
        url = '';
      }
      return origFetch.apply(this, args).then(function (res) {
        if (/\/cart\/(add|change|clear|update|update\.js)/i.test(url)) {
          // Defer so our own note-clear update does not loop forever.
          // Deliberately excludes plain /cart.js reads (used by refreshAndSyncTryOnNote
          // itself and openFromCart) so this guard cannot re-trigger its own fetch.
          setTimeout(function () {
            if (clearingTryOnNote) return;
            if (/\/cart\/update\.js/i.test(url) && /"note"\s*:\s*""/.test(String((args[1] && args[1].body) || ''))) {
              return;
            }
            refreshAndSyncTryOnNote();
          }, 50);
        }
        return res;
      });
    };

    document.addEventListener('cart:updated', refreshAndSyncTryOnNote);
    document.addEventListener('theme:cart:change', refreshAndSyncTryOnNote);
    document.addEventListener('dispatch:cart-drawer:refresh', refreshAndSyncTryOnNote);
  }

  function money(cents) {
    var n = Number(cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function inRanges(postcode, ranges) {
    var n = parseInt(postcode, 10);
    if (!n) return false;
    return ranges.some(function (r) {
      return n >= r[0] && n <= r[1];
    });
  }

  function inTryOnZone(postcode) {
    return inRanges(postcode, TRYON_POSTCODE_RANGES);
  }

  function melbourneOutOfTryOnZone(postcode) {
    return inRanges(postcode, MELBOURNE_METRO_RANGES) && !inTryOnZone(postcode);
  }

  function hourSlots() {
    var out = [];
    for (var h = 9; h <= 20; h++) {
      out.push(pad(h) + ':00');
    }
    return out;
  }

  /** Melbourne calendar Y-M-D (store timezone). */
  function melbourneTodayIso() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Australia/Melbourne',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return isoDate(new Date());
    }
  }

  function melbourneNowHour() {
    try {
      var h = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne',
        hour: '2-digit',
        hourCycle: 'h23'
      }).format(new Date());
      return parseInt(h, 10);
    } catch (e) {
      return new Date().getHours();
    }
  }

  function isSlotPastToday(dateIso, slot) {
    if (dateIso !== melbourneTodayIso()) return false;
    var hour = parseInt(String(slot).slice(0, 2), 10);
    return hour <= melbourneNowHour();
  }

  function TryOnApp(root) {
    this.root = root;
    this.fee = root.getAttribute('data-fee') || '29.00';
    this.feeVariant = root.getAttribute('data-fee-variant');
    this.apiBase = (root.getAttribute('data-api-base') || '').replace(/\/$/, '');
    this.minBoxes = parseInt(root.getAttribute('data-min-boxes') || '1', 10);
    this.maxBoxes = parseInt(root.getAttribute('data-max-boxes') || '3', 10);
    this.step = 1;
    this.items = loadSelection();
    this.postcode = '';
    this.postcodeOk = false;
    this.notes = '';
    this.monthCursor = new Date();
    this.monthCursor.setDate(1);
    this.selectedDate = null;
    this.selectedSlot = null;
    this.busySlots = {};
    /** dates with zero free slots after API check */
    this.fullDays = {};
    this.slotsError = null;
    this.pendingSeed = null;
    this.fromCart = false;
    this.bind();
  }

  TryOnApp.prototype.bind = function () {
    var self = this;
    // Delegation so close/remove keep working after Step 1 re-renders
    this.root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-wl-tryon-close]')) {
        e.preventDefault();
        e.stopPropagation();
        self.close();
        return;
      }
      if (t.closest('[data-wl-tryon-continue-shopping]')) {
        e.preventDefault();
        e.stopPropagation();
        self.close();
        if (typeof self.closeMiniCart === 'function') self.closeMiniCart();
        return;
      }
      if (t.closest('[data-wl-tryon-next]')) {
        e.preventDefault();
        self.next();
        return;
      }
      if (t.closest('[data-wl-tryon-back]')) {
        e.preventDefault();
        self.back();
        return;
      }
      if (t.closest('[data-wl-tryon-check]')) {
        e.preventDefault();
        self.checkPostcode();
        return;
      }
      if (t.closest('[data-wl-tryon-interest-send]')) {
        e.preventDefault();
        self.sendZoneInterest();
        return;
      }
      if (t.closest('[data-wl-tryon-pay]')) {
        e.preventDefault();
        self.pay();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.root.hidden) self.close();
    });
  };

  TryOnApp.prototype.open = function (seedItem) {
    this.pendingSeed = null;
    if (!seedItem) {
      this.fromCart = !!this.fromCart;
    } else {
      this.fromCart = false;
    }
    if (seedItem) {
      if (seedItem.variantId) {
        this.addItem(seedItem);
      } else if (seedItem.variants && seedItem.variants.length) {
        this.pendingSeed = seedItem;
      } else if (seedItem.productId || seedItem.title) {
        // No variants payload — still open; require size before continue if empty
        this.pendingSeed = seedItem;
      }
    }
    this.items = loadSelection();
    this.setInterestVisible(false);
    this.root.hidden = false;
    this.root.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    this.go(1);
    this.render();
    this.renderCartWarn();
  };

  TryOnApp.prototype.close = function () {
    this.pendingSeed = null;
    this.fromCart = false;
    this.root.hidden = true;
    this.root.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    this.renderSizePicker();
    this.renderCartWarn();
  };

  TryOnApp.prototype.renderCartWarn = function () {
    var el = qs('[data-wl-tryon-cart-warn]', this.root);
    if (!el) return;
    el.hidden = !this.fromCart;
  };

  TryOnApp.prototype.closeMiniCart = function () {
    var closeBtn = document.querySelector(
      '#t4s-mini_cart [data-closed-drawer], #t4s-mini_cart .t4s-drawer-close, [data-close-mini_cart], [data-cart-close]'
    );
    if (closeBtn) {
      try {
        closeBtn.click();
      } catch (e) {}
    }
  };

  /**
   * Prefill Try-On selection from Shopify cart (1 unit = 1 shoe box), then open modal.
   */
  TryOnApp.prototype.openFromCart = function () {
    var self = this;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        var items = [];
        (cart.items || []).forEach(function (line) {
          if (!line || line.handle === 'home-try-on-service-fee') return;
          if (String(line.product_type || '').toLowerCase() === 'service') return;
          var size = '';
          if (line.variant_options && line.variant_options.length) {
            size = line.variant_options.filter(Boolean).join(' / ');
          }
          if (!size) size = line.variant_title || '';
          if (size === 'Default Title') size = '';
          var qty = Math.max(1, parseInt(line.quantity, 10) || 1);
          for (var i = 0; i < qty; i++) {
            items.push({
              productId: String(line.product_id || ''),
              handle: line.handle || '',
              title: line.product_title || line.title || 'Shoe',
              image: line.image || '',
              price: String(line.final_price != null ? line.final_price : line.price || ''),
              size: size,
              variantId: String(line.variant_id || '')
            });
          }
        });

        if (!items.length) {
          alert('Add 1–3 pairs with a size selected to book Home Try-On.');
          return;
        }
        if (items.length > self.maxBoxes) {
          alert(
            'Home Try-On is limited to ' +
              self.maxBoxes +
              ' shoe boxes. Please remove some items from your cart first.'
          );
          return;
        }
        var missingSize = items.some(function (it) {
          return !it.variantId || !it.size;
        });
        if (missingSize) {
          alert('Please choose a size for each pair on the product page, then try again.');
          return;
        }

        saveSelection(items);
        self.items = items;
        self.fromCart = true;
        self.closeMiniCart();
        self.open();
      })
      .catch(function () {
        alert('Could not read your cart. Please try again.');
      });
  };

  TryOnApp.prototype.addItem = function (item) {
    var items = loadSelection();
    var key = String(item.variantId || item.productId) + ':' + String(item.size || '');
    var exists = items.some(function (x) {
      return String(x.variantId || x.productId) + ':' + String(x.size || '') === key;
    });
    if (!exists) {
      if (items.length >= this.maxBoxes) {
        alert('You can select up to ' + this.maxBoxes + ' shoe boxes.');
        return;
      }
      items.push(item);
      saveSelection(items);
    }
    this.items = items;
  };

  TryOnApp.prototype.removeItem = function (index) {
    this.items.splice(index, 1);
    saveSelection(this.items);
    this.renderStep1();
    this.updateNav();
  };

  TryOnApp.prototype.go = function (step) {
    this.step = step;
    qsa('[data-wl-step]', this.root).forEach(function (el) {
      el.hidden = parseInt(el.getAttribute('data-wl-step'), 10) !== step;
    });
    var title = qs('[data-wl-tryon-step-title]', this.root);
    if (title) title.textContent = TITLES[step] || '';
    qsa('[data-step-dot]', this.root).forEach(function (dot) {
      var n = parseInt(dot.getAttribute('data-step-dot'), 10);
      dot.classList.toggle('is-active', n === step);
      dot.classList.toggle('is-done', n < step);
    });
    if (step === 1) this.renderStep1();
    if (step === 3) this.renderCalendar();
    if (step === 4) this.renderSummary();
    if (step === 5) this.renderConfirm();
    this.updateNav();
  };

  TryOnApp.prototype.next = function () {
    if (this.step === 1) {
      if (this.pendingSeed) {
        alert('Please choose a size for your Try-On pair.');
        return;
      }
      if (this.items.length < this.minBoxes) return;
      var missing = this.items.some(function (it) {
        return !it.variantId;
      });
      if (missing) {
        alert('Each pair needs a size. Remove incomplete items or pick a size.');
        return;
      }
    }
    if (this.step === 2 && !this.postcodeOk) return;
    if (this.step === 3 && (!this.selectedDate || !this.selectedSlot)) return;
    if (this.step < 5) this.go(this.step + 1);
  };

  TryOnApp.prototype.back = function () {
    if (this.step > 1) this.go(this.step - 1);
  };

  TryOnApp.prototype.updateNav = function () {
    var self = this;
    qsa('[data-wl-step="' + this.step + '"] [data-wl-tryon-next]', this.root).forEach(function (btn) {
      if (self.step === 1) {
        btn.disabled = !!self.pendingSeed || self.items.length < self.minBoxes;
      }
      if (self.step === 2) btn.disabled = !self.postcodeOk;
      if (self.step === 3) btn.disabled = !(self.selectedDate && self.selectedSlot);
    });
  };

  TryOnApp.prototype.render = function () {
    this.renderStep1();
    this.updateNav();
  };

  TryOnApp.prototype.renderSizePicker = function () {
    var self = this;
    var wrap = qs('[data-wl-tryon-size-pick]', this.root);
    var chips = qs('[data-wl-tryon-size-chips]', this.root);
    var title = qs('[data-wl-tryon-size-pick-title]', this.root);
    if (!wrap || !chips) return;

    if (!this.pendingSeed || !this.pendingSeed.variants || !this.pendingSeed.variants.length) {
      wrap.hidden = true;
      chips.innerHTML = '';
      return;
    }

    wrap.hidden = false;
    if (title) {
      title.textContent = 'Choose a size' + (this.pendingSeed.title ? ' — ' + this.pendingSeed.title : '');
    }
    chips.innerHTML = '';
    this.pendingSeed.variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wl-tryon__size-chip';
      btn.textContent = v.size || v.title || String(v.id);
      btn.disabled = v.available === false;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var seed = {
          productId: self.pendingSeed.productId,
          handle: self.pendingSeed.handle,
          title: self.pendingSeed.title,
          image: self.pendingSeed.image,
          price: v.price != null ? v.price : self.pendingSeed.price,
          size: v.size || v.title || '',
          variantId: String(v.id)
        };
        self.pendingSeed = null;
        self.addItem(seed);
        self.items = loadSelection();
        self.renderStep1();
        self.updateNav();
      });
      chips.appendChild(btn);
    });
  };

  TryOnApp.prototype.renderStep1 = function () {
    var self = this;
    var list = qs('[data-wl-tryon-list]', this.root);
    var count = qs('[data-wl-tryon-count]', this.root);
    var upsell = qs('[data-wl-tryon-upsell]', this.root);
    this.renderSizePicker();
    if (!list) return;
    list.innerHTML = '';
    this.items.forEach(function (item, idx) {
      var li = document.createElement('li');
      li.className = 'wl-tryon__item';
      li.innerHTML =
        '<img src="' +
        (item.image || '') +
        '" alt="" width="64" height="64" loading="lazy">' +
        '<div><p class="wl-tryon__item-title"></p><p class="wl-tryon__item-meta"></p></div>' +
        '<button type="button" class="wl-tryon__remove" aria-label="Remove">&times;</button>';
      li.querySelector('.wl-tryon__item-title').textContent = item.title || 'Shoe';
      li.querySelector('.wl-tryon__item-meta').textContent =
        (item.size ? 'Size: ' + item.size : '') + (item.price ? ' · ' + money(item.price) : '');
      li.querySelector('.wl-tryon__remove').addEventListener('click', function () {
        self.removeItem(idx);
      });
      list.appendChild(li);
    });
    if (count) count.textContent = this.items.length + ' / ' + this.maxBoxes + ' shoe boxes selected';
    if (upsell) upsell.hidden = !(this.items.length === 1 && this.maxBoxes > 1);
    var shopMore = qs('[data-wl-tryon-continue-shopping]', this.root);
    if (shopMore) {
      // Show when at least one pair is locked in — same for PDP/card and cart entry
      shopMore.hidden = !(this.items.length > 0 && !this.pendingSeed);
    }
    this.renderCartWarn();
  };

  TryOnApp.prototype.setInterestVisible = function (show) {
    var box = qs('[data-wl-tryon-interest]', this.root);
    var ok = qs('[data-wl-tryon-interest-ok]', this.root);
    var hint = qs('[data-wl-tryon-interest-hint]', this.root);
    var email = qs('[data-wl-tryon-interest-email]', this.root);
    var send = qs('[data-wl-tryon-interest-send]', this.root);
    if (!box) return;
    box.hidden = !show;
    if (!show) {
      if (ok) {
        ok.hidden = true;
        ok.textContent = '';
      }
      if (hint) hint.hidden = false;
      if (email) {
        email.disabled = false;
        email.value = '';
      }
      if (send) send.hidden = false;
    }
  };

  TryOnApp.prototype.sendZoneInterest = function () {
    var self = this;
    var emailEl = qs('[data-wl-tryon-interest-email]', this.root);
    var okEl = qs('[data-wl-tryon-interest-ok]', this.root);
    var hint = qs('[data-wl-tryon-interest-hint]', this.root);
    var send = qs('[data-wl-tryon-interest-send]', this.root);
    var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
    var postcode = this.postcode || '';

    if (!okEl) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      okEl.hidden = false;
      okEl.className = 'wl-tryon__alert is-err';
      okEl.textContent = 'Enter a valid email address.';
      return;
    }
    if (!this.apiBase) {
      okEl.hidden = false;
      okEl.className = 'wl-tryon__alert is-err';
      okEl.textContent = 'Could not send right now. Please try again later.';
      return;
    }

    if (send) send.disabled = true;
    fetch(this.apiBase + '/api/zone-interest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, postcode: postcode })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok || (res.j && res.j.error && !res.j.ok)) {
          okEl.hidden = false;
          okEl.className = 'wl-tryon__alert is-err';
          okEl.textContent = (res.j && (res.j.error || res.j.message)) || 'Could not send. Please try again.';
          if (send) send.disabled = false;
          return;
        }
        okEl.hidden = false;
        okEl.className = 'wl-tryon__alert is-ok';
        okEl.textContent = (res.j && res.j.message) || MSG_INTEREST_OK;
        if (hint) hint.hidden = true;
        if (emailEl) emailEl.disabled = true;
        if (send) send.hidden = true;
      })
      .catch(function () {
        okEl.hidden = false;
        okEl.className = 'wl-tryon__alert is-err';
        okEl.textContent = 'Network error. Please try again.';
        if (send) send.disabled = false;
      });
  };

  TryOnApp.prototype.checkPostcode = function () {
    var self = this;
    var input = qs('[data-wl-tryon-postcode]', this.root);
    var msg = qs('[data-wl-tryon-postcode-msg]', this.root);
    var feeBox = qs('[data-wl-tryon-fee-box]', this.root);
    var notes = qs('[data-wl-tryon-notes]', this.root);
    this.postcode = (input && input.value ? input.value : '').trim();
    this.notes = notes ? notes.value.trim() : '';
    msg.hidden = false;
    msg.className = 'wl-tryon__alert';

    function apply(ok, text, showInterest) {
      self.postcodeOk = ok;
      msg.className = 'wl-tryon__alert ' + (ok ? 'is-ok' : 'is-err');
      msg.textContent = text;
      msg.hidden = false;
      if (feeBox) feeBox.hidden = !ok;
      self.setInterestVisible(!!showInterest);
      self.updateNav();
    }

    if (!/^\d{4}$/.test(this.postcode)) {
      apply(false, 'Please enter a valid 4-digit Australian postcode.', false);
      return;
    }

    if (this.apiBase) {
      fetch(this.apiBase + '/api/check-postcode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postcode: this.postcode })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data && data.available) {
            apply(true, (data && data.message) || MSG_POSTCODE_OK, false);
          } else {
            var interest = !!(data && (data.showInterestForm || data.melbourneOutOfZone));
            apply(
              false,
              (data && data.message) || (interest ? MSG_POSTCODE_MEL_INTEREST : MSG_POSTCODE_OUT),
              interest
            );
          }
        })
        .catch(function () {
          if (inTryOnZone(self.postcode)) {
            apply(true, MSG_POSTCODE_OK, false);
          } else {
            var interest = melbourneOutOfTryOnZone(self.postcode);
            apply(false, interest ? MSG_POSTCODE_MEL_INTEREST : MSG_POSTCODE_OUT, interest);
          }
        });
      return;
    }

    if (inTryOnZone(this.postcode)) {
      apply(true, MSG_POSTCODE_OK, false);
    } else {
      var interest = melbourneOutOfTryOnZone(this.postcode);
      apply(false, interest ? MSG_POSTCODE_MEL_INTEREST : MSG_POSTCODE_OUT, interest);
    }
  };

  TryOnApp.prototype.renderCalendar = function () {
    var self = this;
    var cal = qs('[data-wl-tryon-calendar]', this.root);
    if (!cal) return;
    var y = this.monthCursor.getFullYear();
    var m = this.monthCursor.getMonth();
    var first = new Date(y, m, 1);
    var startDow = first.getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var todayIso = melbourneTodayIso();
    var monthName = first.toLocaleString('en-AU', { month: 'long', year: 'numeric' });

    var html =
      '<div class="wl-tryon__cal-head"><button type="button" class="wl-tryon__cal-nav" data-cal-prev aria-label="Previous month">‹</button><span>' +
      monthName +
      '</span><button type="button" class="wl-tryon__cal-nav" data-cal-next aria-label="Next month">›</button></div>';
    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) {
      html += '<div class="wl-tryon__dow">' + d + '</div>';
    });
    for (var i = 0; i < startDow; i++) html += '<div></div>';
    for (var day = 1; day <= daysInMonth; day++) {
      var d = new Date(y, m, day);
      var iso = isoDate(d);
      var past = iso < todayIso;
      var full = !!this.fullDays[iso];
      var disabled = past || full;
      var selected = this.selectedDate === iso;
      html +=
        '<button type="button" class="wl-tryon__day' +
        (selected ? ' is-selected' : '') +
        (full ? ' is-unavailable' : '') +
        '" data-date="' +
        iso +
        '"' +
        (disabled ? ' disabled' : '') +
        (full ? ' title="No times available"' : '') +
        '>' +
        day +
        '</button>';
    }
    cal.innerHTML = html;
    var prev = cal.querySelector('[data-cal-prev]');
    var next = cal.querySelector('[data-cal-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        self.monthCursor.setMonth(self.monthCursor.getMonth() - 1);
        self.renderCalendar();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        self.monthCursor.setMonth(self.monthCursor.getMonth() + 1);
        self.renderCalendar();
      });
    }
    qsa('[data-date]', cal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectedDate = btn.getAttribute('data-date');
        self.selectedSlot = null;
        self.loadSlots().then(function () {
          self.renderCalendar();
          self.renderSlots();
          self.updateNav();
        });
      });
    });
    this.renderSlots();
  };

  TryOnApp.prototype.loadSlots = function () {
    var self = this;
    if (!this.selectedDate) return Promise.resolve();
    this.slotsError = null;
    if (!this.apiBase) {
      this.busySlots[this.selectedDate] = [];
      this.fullDays[this.selectedDate] = false;
      return Promise.resolve();
    }
    return fetch(this.apiBase + '/api/available-slots?date=' + encodeURIComponent(this.selectedDate))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var all = hourSlots();
        var available = Array.isArray(data && data.slots) ? data.slots.slice() : [];
        if (data && data.source === 'fallback-error') {
          self.slotsError =
            (data && data.message) ||
            'Times are temporarily unavailable. Please try again shortly.';
          available = [];
        }
        available = available.filter(function (s) {
          return !isSlotPastToday(self.selectedDate, s);
        });
        self.busySlots[self.selectedDate] = all.filter(function (s) {
          return available.indexOf(s) === -1;
        });
        self.fullDays[self.selectedDate] = available.length === 0;
        if (self.selectedSlot && available.indexOf(self.selectedSlot) === -1) {
          self.selectedSlot = null;
        }
      })
      .catch(function () {
        self.slotsError = 'Times are temporarily unavailable. Please try again shortly.';
        self.busySlots[self.selectedDate] = hourSlots().slice();
        self.fullDays[self.selectedDate] = true;
        self.selectedSlot = null;
      });
  };

  TryOnApp.prototype.renderSlots = function () {
    var self = this;
    var wrap = qs('[data-wl-tryon-slots]', this.root);
    if (!wrap) return;
    wrap.innerHTML = '';
    if (!this.selectedDate) {
      wrap.innerHTML = '<p class="wl-tryon__hint">Select a date to see available times.</p>';
      return;
    }
    if (this.slotsError) {
      wrap.innerHTML = '<p class="wl-tryon__hint">' + this.slotsError + '</p>';
      return;
    }
    var busy = this.busySlots[this.selectedDate] || [];
    var freeCount = 0;
    hourSlots().forEach(function (slot) {
      var isBusy = busy.indexOf(slot) !== -1 || isSlotPastToday(self.selectedDate, slot);
      if (!isBusy) freeCount += 1;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wl-tryon__slot' + (self.selectedSlot === slot ? ' is-selected' : '');
      btn.textContent = slot;
      if (isBusy) btn.disabled = true;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self.selectedSlot = slot;
        self.renderSlots();
        self.updateNav();
      });
      wrap.appendChild(btn);
    });
    if (freeCount === 0) {
      var note = document.createElement('p');
      note.className = 'wl-tryon__hint';
      note.textContent = 'No times available this day. Please choose another date.';
      wrap.appendChild(note);
    }
  };

  TryOnApp.prototype.renderSummary = function () {
    var el = qs('[data-wl-tryon-summary]', this.root);
    if (!el) return;
    var notes = qs('[data-wl-tryon-notes]', this.root);
    this.notes = notes ? notes.value.trim() : this.notes;
    var shoes = this.items
      .map(function (i) {
        return '<li>' + (i.title || 'Shoe') + (i.size ? ' — Size ' + i.size : '') + '</li>';
      })
      .join('');
    el.innerHTML =
      '<p><strong>Appointment</strong><br>' +
      (this.selectedDate || '') +
      ' · ' +
      (this.selectedSlot || '') +
      '</p>' +
      '<p style="margin-top:12px"><strong>Delivery</strong><br>Postcode ' +
      this.postcode +
      (this.notes ? '<br>' + this.notes : '') +
      '</p>' +
      '<p style="margin-top:12px"><strong>Shoes</strong></p><ul>' +
      shoes +
      '</ul>';
  };

  TryOnApp.prototype.renderConfirm = function () {
    var el = qs('[data-wl-tryon-confirm]', this.root);
    if (!el) return;
    el.innerHTML =
      '<p>' +
      (this.selectedDate || '') +
      ' at ' +
      (this.selectedSlot || '') +
      '<br>Postcode ' +
      this.postcode +
      '</p>';
  };

  TryOnApp.prototype.pay = function () {
    var self = this;
    if (!this.feeVariant) {
      alert('Service fee product is not configured.');
      return;
    }
    var notes = qs('[data-wl-tryon-notes]', this.root);
    this.notes = notes ? notes.value.trim() : this.notes;

    var booking = {
      postcode: this.postcode,
      notes: this.notes,
      date: this.selectedDate,
      slot: this.selectedSlot,
      items: this.items,
      fee: this.fee,
      createdAt: new Date().toISOString()
    };
    sessionStorage.setItem(BOOKING_KEY, JSON.stringify(booking));

    /* Visible properties (no leading _) show in Shopify Checkout under the fee line.
       Hidden _wl_* keys stay for webhook / Draft Order automation. */
    var shoesLabel = this.items
      .map(function (i, idx) {
        return idx + 1 + '. ' + (i.title || 'Shoe') + (i.size ? ' — Size ' + i.size : '');
      })
      .join('; ')
      .slice(0, 255);
    var appointment = ((this.selectedDate || '') + ' · ' + (this.selectedSlot || '')).trim();

    var props = {
      'Booking type': 'Home Try-On',
      Appointment: appointment,
      Postcode: this.postcode || '',
      'Shoes for try-on': shoesLabel || '—',
      'Delivery notes': (this.notes || '—').slice(0, 250),
      _wl_tryon: '1',
      _wl_tryon_date: this.selectedDate || '',
      _wl_tryon_slot: this.selectedSlot || '',
      _wl_tryon_postcode: this.postcode || '',
      _wl_tryon_notes: (this.notes || '').slice(0, 250),
      _wl_tryon_items: this.items
        .map(function (i) {
          return (i.title || '') + (i.size ? ' / ' + i.size : '') + (i.variantId ? ' #' + i.variantId : '');
        })
        .join(' | ')
        .slice(0, 250)
    };

    var formData = {
      items: [
        {
          id: Number(this.feeVariant),
          quantity: 1,
          properties: props
        }
      ]
    };

    var orderNote = [
      'HOME TRY-ON BOOKING',
      'Appointment: ' + appointment,
      'Postcode: ' + (this.postcode || ''),
      'Shoes: ' + (shoesLabel || '—'),
      'Delivery notes: ' + (this.notes || '—')
    ].join('\n');

    /* clear.js removes lines but may leave a previous cart note — wipe first */
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: '' })
        });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData)
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        /* Cart note → Order "Notes" in Admin (visible to merchant) */
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: orderNote })
        });
      })
      .then(function (r) {
        if (r && !r.ok) throw new Error('Cart note failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        alert('Could not start checkout. Please try again.');
      });
  };

  function currentVariantSize() {
    var checked = document.querySelector(
      'input[name="id"]:checked, form[action*="/cart/add"] [name="id"]'
    );
    var form = document.querySelector('form[action*="/cart/add"], product-form form, .t4s-product-form');
    var size = '';
    if (form) {
      var selects = form.querySelectorAll('select, input[type="radio"]:checked');
      selects.forEach(function (el) {
        var name = (el.getAttribute('name') || el.getAttribute('data-name') || '').toLowerCase();
        if (name.indexOf('size') !== -1 || name.indexOf('option') !== -1) {
          size = el.value || (el.nextElementSibling ? el.nextElementSibling.textContent : '') || size;
        }
      });
      var active = form.querySelector('.is--selected, .is-selected, [aria-checked="true"]');
      if (!size && active) size = (active.textContent || '').trim();
    }
    var variantId = checked ? checked.value : null;
    if (!variantId && window.meta && window.meta.product && window.meta.product.variants) {
      variantId = window.meta.product.variants[0] && window.meta.product.variants[0].id;
    }
    return { size: size, variantId: variantId };
  }

  function parseVariantsAttr(raw) {
    if (!raw) return [];
    try {
      var data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return [];
    }
  }

  function seedFromButton(btn) {
    var v = currentVariantSize();
    var variants = parseVariantsAttr(btn.getAttribute('data-wl-tryon-variants'));
    var onCard = btn.classList.contains('wl-tryon-card-btn');
    // PDP CTA: use form selection. Card button: ignore PDP form — pick size in modal.
    var size = onCard ? '' : v.size || '';
    var variantId = onCard ? '' : v.variantId || '';
    if (!variantId && variants.length === 1 && variants[0].available !== false) {
      variantId = String(variants[0].id);
      size = variants[0].size || variants[0].title || size;
    }
    return {
      productId: btn.getAttribute('data-wl-tryon-product-id'),
      handle: btn.getAttribute('data-wl-tryon-product-handle'),
      title: btn.getAttribute('data-wl-tryon-product-title'),
      image: btn.getAttribute('data-wl-tryon-product-image'),
      price: btn.getAttribute('data-wl-tryon-product-price'),
      size: size,
      variantId: variantId ? String(variantId) : '',
      variants: variants
    };
  }

  function init() {
    installCartNoteGuard();
    /* Always scrub stale Try-On cart notes (even if modal root missing on a page) */
    refreshAndSyncTryOnNote();

    var root = qs('[data-wl-tryon-root]');
    if (!root) return;
    var app = new TryOnApp(root);
    window.WeloraTryOn = app;

    document.addEventListener(
      'click',
      function (e) {
        var fromCart = e.target.closest('[data-wl-tryon-from-cart]');
        if (fromCart) {
          if (fromCart.disabled || fromCart.getAttribute('aria-disabled') === 'true') return;
          e.preventDefault();
          e.stopPropagation();
          app.openFromCart();
          return;
        }
        var btn = e.target.closest('[data-wl-tryon-open]');
        if (!btn) return;
        // Ignore open triggers that live inside the modal chrome itself
        if (btn.closest('[data-wl-tryon-dialog]')) return;
        e.preventDefault();
        e.stopPropagation();
        app.open(seedFromButton(btn));
      },
      true
    );

    /* After returning from checkout success page with booking in session — show step 5 if needed */
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('wl_tryon') === 'confirmed' && sessionStorage.getItem(BOOKING_KEY)) {
        var booking = JSON.parse(sessionStorage.getItem(BOOKING_KEY));
        app.postcode = booking.postcode;
        app.selectedDate = booking.date;
        app.selectedSlot = booking.slot;
        app.items = booking.items || [];
        app.open();
        app.go(5);
        /* Booking completed — drop cart note leftovers if any */
        clearStaleTryOnNote();
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
